export default "__VITE_ASSET__Duzumeg0__"